import api from "..";
import Env from '../../config/environments';
import { ApiEndpoint, Method } from "../../constants";

const params = {};
const body = {};

export const getTeacherStatics = (teacherId) => {
  return api(`${ApiEndpoint.STATICS_SERVICE}/teacher/${teacherId}`, Method.GET, params, Env.BASE_URL, body);
}